import { API_URL, ADMINS_URL } from '@Config/config'

import instance from '../instance'

export class SettingsController {
    onRemoveBugReport(id: string) {
        return instance.delete(`${API_URL}/bug-reports?bugReportId=${id}`)
    }

    onGetBugReportList() {
        return instance.get(`${API_URL}/bug-reports`)
    }

    onUploadAppLogo(dto: FormData) {
        return instance.put(`${API_URL}/storage/logo.png`, dto)
    }

    onGetSlotsByAgentId(agentId: string) {
        return instance.get(`${API_URL}${ADMINS_URL}/slots/info?agentId=${agentId}`)
    }

    onRefundRecord(queries: string) {
        return instance.delete(`${API_URL}${ADMINS_URL}/slot/refund${queries}`)
    }
}
